import { useCallback, useState } from "react";
import { RepoService } from "../Service/RepoService";

export interface RepoViewModel {
    repos: string[];
    branches: string[];
    
    fetchRepos: () => Promise<void>;
    fetchBranches: (repoName: string) => Promise<void>;
}

export const useRepoViewModel = () => {
    const [repoData, setRepoData] = useState<string[]>([]);
    const [branchData, setBranchData] = useState<string[]>([]);

    const fetchRepos = useCallback(async () => {
        try {
         const res = await RepoService.getRepos();
         if (Array.isArray(res) && res.every(item => typeof item === "string")) {
            setRepoData(res);
          } else {
            console.error("Invalid response format:", res);
          }
        } catch (error) {
          console.error("Failed to fetch repos:", error);
        }
    }, []);

    const fetchBranches = useCallback(async (repoName: string) => {
      try {
       const res = await RepoService.getBranches(repoName);
       if (Array.isArray(res) && res.every(item => typeof item === "string")) {
          setBranchData(res);
        } else {
          console.error("Invalid response format:", res);
        }
      } catch (error) {
        console.error("Failed to fetch branches:", error);
      }
    }, []);

    return {
        // State
        repos: repoData,
        branches: branchData,
      
        // Actions
        fetchRepos,
        fetchBranches,
    };
}